
import { useEffect, useState } from "react"
import styles from "../css/Ordenes.module.css"
import miAxios from "../api/axios"
import { useAuth } from "../hooks/AuthProvider"
import { IconButton, TextField, FormControlLabel, Switch } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import Confirmacion from "../components/Conformacion"

const soloNumeros = (texto) => {
    let nums = "0123456789."
    let res = ""
    for (var i = 0; i < texto.length; i++) {
        let s = texto[i]
        if (nums.indexOf(s) > -1) {
            res = res + s
        }
    }
    return res;
}

const getInicio = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-01-' + dd;
    return today;
}

const getHoy = () => {
    const cual = new Date();
    var mm = cual.getMonth() + 1;
    var dd = cual.getDate()
    var yyyy = cual.getFullYear();
    if (mm < 10) {
        mm = '0' + mm;
    }
    if (dd < 10) {
        dd = '0' + dd;
    }
    var today = yyyy + '-' + mm + '-' + dd;
    return today;
}

export default function Ordenes(props) {
    const [rows, setRows] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState({ open: false, id: 0 })
    const [desde, setDesde] = useState(getInicio())
    const [hasta, setHasta] = useState(getHoy())
    const [soloPendientes, setSoloPendientes] = useState(false)

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actRows()
    }, [])

    useEffect(() => {
        actRows()
    }, [desde, hasta, soloPendientes])

    const actRows = async () => {
        setProcesando(true)

        try {
            const response = await axios.get("/despachos/historico2?desde=" + desde + "&hasta=" + hasta + "&solo_pendientes=" + soloPendientes)

            const data = response.data;
            if (data.respuesta == "S") {
                setRows(data.lista)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleImprimir = (cual) => {
        window.open("/reportes/orden?id=" + cual, "_blank")
    }

    const anular = async (cual) => {
        setOpenConfirmacion({
            open: false,
            id: 0
        })
        setProcesando(true)

        try {
            const response = await axios.post("/despachos/anular?cual=" + cual)

            const data = response.data;
            if (data.respuesta == "S") {
                actRows()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleAnular = () => {
        const n = rows.filter((r) => r.id == openConfirmacion.id)
        if (n[0].estatus != "Despachado") {
            setMensaje("Estatus incorrecto!")
            return;
        }
        anular(openConfirmacion.id)

    }

    return <div className={styles.cuerpo}>
        {
            openConfirmacion.open && (
                <Confirmacion open={openConfirmacion.open} texto="¿Desea ANULAR este despacho?" exito={() => { handleAnular() }} cancelar={() => { setOpenConfirmacion({ open: false, id: 0 }) }} />
            )
        }
        <div className={styles.header}>
            Histórico Ordenes
        </div>
        <div className={styles.filtro}>
            <div>
                <TextField
                    value={desde}
                    label="Desde"
                    type="date"
                    size="small"
                    color="coopinfa"
                    onChange={(event) => { setDesde(event.target.value) }}
                />
            </div>
            <div>
                <TextField
                    value={hasta}
                    label="Hasta"
                    type="date"
                    size="small"
                    color="coopinfa"
                    onChange={(event) => { setHasta(event.target.value) }}
                />
            </div>
            <div>
                <FormControlLabel
                    control={<Switch size="small" checked={soloPendientes}
                        color="coopinfa"
                        onChange={(event) => { setSoloPendientes(event.target.checked) }} />}
                    label="Solo pendientes"
                />
            </div>
        </div>
        <div className={styles.tabla}>
            <table width={"100%"}>
                <thead>
                    <tr className={styles.rows}>
                        <th>Orden #</th>
                        <th>Fecha</th>
                        <th>Monto</th>
                        <th>Cédula</th>
                        <th>Nombre</th>
                        <th>Whatsapp</th>
                        <th>Estatus</th>
                        <th>Despacho #</th>
                        <th>Fecha despachada</th>
                        <th>Monto Despacho</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.map((row) => {
                            return <tr className={styles.rows} key={row.id}>
                                <td>{row.numero}</td>
                                <td>{row.fecha}</td>
                                <td>
                                    {parseFloat(row.monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                                <td>{row.cedula}</td>
                                <td>{row.nombre}</td>
                                <td>{row.whatsapp}</td>
                                <td>{row.estatus}</td>
                                <td>{row.estatus != "Pendiente" && (row.despacho_numero)}</td>
                                <td>{row.estatus != "Pendiente" && (row.despacho_fecha)}</td>
                                <td>
                                    {row.estatus != "Pendiente" && (parseFloat(row.despacho_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </div>
    </div>
}